<div class="container">

  <app-breadcrumb [url]="goback"></app-breadcrumb>

  <div class="title">
    <h2>Alterar Senha</h2>
  </div>

  <mat-card>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutAlign.lt-md="start center" class="title__sub-title">
      <mat-icon class="icons__info">vpn_key</mat-icon>
      <div>Preencha os campos para a troca de senha</div>
    </div>

    <form [formGroup]="passwordForm">
      <div fxLayout="row" fxLayout.lt-md="column">

        <mat-form-field appearance="outline" fxFlex="50" fxFlex.lt-md="100">
          <mat-label>Senha</mat-label>
          <input matInput id="password" name="password" formControlName="password" [type]="hidePassword ? 'password' : 'text'"/>
          <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword"
            [attr.aria-label]="'hidePassword password'" [attr.aria-pressed]="hidePassword" >
            <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-hint *ngIf="!passwordForm.get('password').valid && passwordForm.get('password').touched" class="error__input">
            {{ passwordForm.get('password').errors | errorMessageFG }}
          </mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex="50" fxFlex.lt-md="100">
          <mat-label>Confirmação de Senha</mat-label>
          <input matInput id="confirmPassword" name="confirmPassword" formControlName="confirmPassword" [type]="hideConfirmPassword ? 'password' : 'text'"/>
          <button mat-icon-button matSuffix type="button" (click)="hideConfirmPassword = !hideConfirmPassword"
            [attr.aria-label]="'hideConfirmPassword password'" [attr.aria-pressed]="hideConfirmPassword" >
            <mat-icon>{{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-hint *ngIf="!passwordForm.get('confirmPassword').valid && passwordForm.get('confirmPassword').touched" class="error__input">
            {{ passwordForm.get('confirmPassword').errors | errorMessageFG }}
          </mat-hint>
        </mat-form-field>

      </div>

      <div class="btn__footer__container" fxLayout="row" fxLayoutAlign="end center">
        <button mat-raised-button color="primary" class="btn__add" (click)="update()">Alterar</button>
      </div>
    </form>
  </mat-card>

</div>
